import React from 'react';
import {FontWeightMedium} from 'src/res/FontWeight';
import {logDebug} from "../../utils/AppLog";
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import ImageBackground from "../commons/ImageBackground";
import AppImage from "../commons/AppImage";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils from "../../utils/AppUtils";
import {
  GAME_CRUSH_AUDIO,
  GAME_NEUTRAL_AUDIO,
  GAME_TIMER_AUDIO,
  GAME_WIN_AUDIO
} from "../../utils/GameAudioPlayer";
import AppText from "../commons/AppText";
import FocusHelperView from "../commons/FocusHelperView";
import GameAudio from "../commons/GameAudio";
import ActivityHelper from "../../utils/ActivityHelper";
import TouchableOpacity from "../commons/TouchableOpacity";

export default class GamePuzzleTapSelectView extends React.PureComponent {

  constructor(props) {
    super(props);
    this.gameLastTime = 0;
    this.endGameProcessStartTime = 0;
    this.puzzlePieces = null;

    this.state = this.getDefaultState();
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
      this.timeoutRef = null;
    }
    this.stopGameTimer();
  }

  onDidFocus = () => {
      if (this.wasTimerRunning) {
      this.startGameTimer();
    }
  }

  onDidBlur = () => {
    if (this.intervalHandler) {
      this.wasTimerRunning = true;
      this.stopGameTimer();
    }
  }

  simulatePlay = (key = 0) => {
    if (!this.state.isGameOver) {
      const row = Math.floor(key / this.props.rows);
      const col = key % this.props.columns;
      const passCount = Math.random() > 0.5 ? 1 : 2;
      this.clickRowColumnUntilCorrect(key, row, col, passCount);
    }
  }

  clickRowColumnUntilCorrect = (key, row, col, pass) => {
    let gridDS = this.refGrid.getGridData();
    const tileData = gridDS[row][col];
    if (tileData.selectedKey !== key || pass > 1) {
      this.timeoutRef = setTimeout(() => {
        if (!this.state.isGameOver) {
          tileData.selectedIndex = (tileData.selectedIndex + 1) % tileData.pieces.length;
          tileData.selectedKey = tileData.pieces[tileData.selectedIndex];
          this.refGrid.onCardChange();

          if (tileData.selectedKey !== key) {
            pass--;
          }
          this.clickRowColumnUntilCorrect(key, row, col, pass);
        }
      }, 700);
    } else if (key < this.props.rows * this.props.columns - 1) {
      this.simulatePlay(++key);
    }
  }

  resetForPreview(items) {
    this.reset(items);
  }

  reset(items) {
    this.stopGameTimer(false);
    setTimeout(() => {
      const currentTime = new Date().getTime();
      const idleTime = 2 * 1000;
      const resetAfter = Math.max(0, idleTime - (currentTime - this.endGameProcessStartTime));

      setTimeout(() => {
        this.endGameProcessStartTime = 0;
        this.puzzlePieces = null;
        this.setState(this.getDefaultState());
        if (this.refGrid) {
          this.refGrid.reset();
        }
      }, resetAfter);
    }, 100);
  }

  getDefaultState() {
    return {
      isGameOver: false,
      isWin: false,
      isLose: false,
      gameTimer: 0,
      movesCount: 0,
    };
  }

  playGamePlayAudio() {
    if (this.gamePlayAudioId) {
      this.gamePlayAudioId.play();
    }
  }

  playGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.play();
    }
  }

  stopGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.pause();
    }
  }

  render() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const isDisabled = this.props.disabled;
    const rows = this.props.rows;
    const columns = this.props.columns;
    const isRTL = !this.props.isLTR;

    const cardSize = this.getCardSize();
    const cardSpacing = this.getCardSpacing();
    const gameViewWidth = Math.ceil((cardSize + cardSpacing) * columns + 1);
    const gameViewHeight = Math.ceil((cardSize + cardSpacing) * rows + 1);
    const gameBgMargin = uiConfigs.gameBgMarginStartEnd * sizeFactor;
    const gameBgMarginTop = uiConfigs.gameBgMarginTop * sizeFactor;
    const gameBgMarginBottom = uiConfigs.gameBgMarginBottom * sizeFactor;

    const gameTimeLeft = ActivityHelper.getGameTimeText(this.props.gameTime - this.state.gameTimer);
    const showMovesCount = this.props.flipsNeeded && (this.props.flipsNeeded < 10000 || this.props.flipsNeeded - this.state.movesCount < 10000);
    let flipsCountText = null;
    if (showMovesCount) {
      flipsCountText = Math.max(0, this.props.flipsNeeded - this.state.movesCount);
    }
    return (
      <View style={{alignItems: 'center'}}>
        <FocusHelperView
          onNavigationDidFocus={this.onDidFocus}
          onNavigationDidBlur={this.onDidBlur}
          onAppDidFocus={this.onDidFocus}
          onAppDidBlur={this.onDidBlur}
        />
        {!this.props.disableAudio ?
          <div>
            <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gamePlayAudioUrl || GAME_CRUSH_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gameTimerAudioId = ref} source={GAME_TIMER_AUDIO} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
          </div>
          : null
        }
        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: -4}}>
          {showMovesCount || this.props.gameTime ?
            <View style={{marginLeft: isRTL ? 40 * sizeFactor : 0, marginRight: isRTL ? 0 : 40 * sizeFactor}}>
              {showMovesCount ?
                <ImageBackground source={uiConfigs.tryCounterImage} resizeMode="fill" style={{height: 44 * sizeFactor, width: 130 * sizeFactor, display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 8, paddingTop: 4}} >
                  <AppText fontSizeN={uiConfigs.fontSize} style={{align: 'center', position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, flex: 1, marginLeft: 48 * sizeFactor, marginRight: 4 * sizeFactor, marginTop: 2 * sizeFactor, justifyContent: 'center'}}>
                    {flipsCountText}
                  </AppText>
                </ImageBackground>
                : null
              }
              {this.props.gameTime ?
                <ImageBackground source={uiConfigs.timerImage} resizeMode="fill" style={{height: 44 * sizeFactor, width: 130 * sizeFactor, display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: 4}} >
                  <AppText fontSizeN={uiConfigs.fontSize} style={{align: 'center',position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, flex: 1, marginLeft: 48 * sizeFactor, marginRight: 4 * sizeFactor, marginTop: 4 * sizeFactor, justifyContent: 'center'}}>
                    {gameTimeLeft}
                  </AppText>
                </ImageBackground>
                : null
              }
            </View>
            : null
          }
          <ImageBackground source={uiConfigs.gameMediaImage} resizeMode="fill" style={{height: 104 * sizeFactor, width: 96 * sizeFactor, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 8 * sizeFactor, paddingBottom: 16 * sizeFactor, paddingTop: 24 * sizeFactor}}>
            <TouchableOpacity onClick={this.onPuzzleImageClicked}>
              <AppImage imageUrl={this.props.puzzleImage} style={{position: 'relative', width: 80 * sizeFactor, height: 80 * sizeFactor, borderRadius: 8 * sizeFactor, borderWidth: 1, borderColor: 'rgb(99,99,99)'}}/>
            </TouchableOpacity>
          </ImageBackground>
        </View>
        <ImageBackground source={uiConfigs.gameBgImage} resizeMode="fill" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', height: gameViewHeight + gameBgMarginTop + gameBgMarginBottom, width: gameViewWidth + 2 * gameBgMargin, padding: gameBgMargin - 2, paddingTop: gameBgMarginTop - 1, paddingBottom: gameBgMarginBottom - 1, overflow: 'hidden', opacity: isDisabled ? 0.8 : 1}}>
          <Grid
            ref={this.handleRefGrid}
            isLTR={this.props.isLTR}
            items={this.items}
            rows={this.props.rows}
            columns={this.props.columns}
            size={cardSize}
            imageUrl={this.props.puzzleImage}
            won={this.props.won}
            countPerPiece={4}
            onChange={this.onChange}
          />
          {this.state.isGameOver || isDisabled
            ? <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 1}} />
            : null
          }
          {!this.props.simulation && (this.state.isWin || this.state.isLose) ?
            <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, alignItems: 'center', justifyContent: 'center'}}>
              {/*<View>*/}
              {/*  <View style={{padding: 8, paddingLeft: 16, paddingRight: 16, marginBottom: 4, backgroundColor: AppUtils.colorWithAlpha(uiConfigs.messageBgColor, 0.9), borderRadius: 20}}>*/}
              {/*    <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium}}>*/}
              {/*      {this.state.isWin ? locString('youWon') : locString('gameEnded')}*/}
              {/*    </AppText>*/}
              {/*  </View>*/}
                <CircularProgress size={uiConfigs.fontSize * 2} style={{color: uiConfigs.messageBgColor}}/>
              {/*</View>*/}
            </View>
            : null
          }
        </ImageBackground>
      </View>
    );
  }

  handleRefGrid = (ref) => {
    this.refGrid = ref;
  }

  onPuzzleImageClicked = () => {
    this.props.onImageClicked(this.props.puzzleImage);
  };

  onChange = (keys) => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }
    if (this.state.movesCount === 0) {
      if (this.props.onStart) {
        this.props.onStart();
      }
    }

    this.startGameTimer();
    const movesCount = this.state.movesCount + 1;
    const isGameOver = this.processGameResult(keys, movesCount, this.state.gameTimer);
    if (isGameOver) {
      this.stopGameTimer();
    }
    this.puzzlePieces = keys;
    this.setState({
      movesCount: movesCount,
      isGameOver: isGameOver
    });
    this.playGamePlayAudio();
  };

  startGameTimer() {
    if (this.props.gameTime && !this.intervalHandler) {
      this.gameLastTime = new Date().getTime();
      this.intervalHandler = setInterval(() => {
        this.updateTimeElapsed();
      }, 500);
      this.playGameTimerAudio();
    }
  }

  stopGameTimer() {
    if (this.intervalHandler) {
      this.stopGameTimerAudio();
      clearInterval(this.intervalHandler);
      this.intervalHandler = null;
      this.updateTimeElapsed();
    }
  }

  updateTimeElapsed() {
    let isGameOver = false;

    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.gameLastTime;
    this.gameLastTime = currentTime;
    const timeElapsed = Math.min(this.state.gameTimer + timeDiff, this.props.gameTime);
    const timeOver = timeElapsed >= this.props.gameTime;
    if (timeOver) {
      this.stopGameTimer();
      isGameOver = this.processGameResult(this.puzzlePieces, this.state.movesCount, timeElapsed);
    }
    this.setState({
      gameTimer: timeElapsed,
      isGameOver: isGameOver
    });
  }

  isGameWin(puzzlePieces) {
    for (let i = 0; i < this.props.rows * this.props.columns; i++) {
      if (puzzlePieces[i] !== i) {
        return false;
      }
    }
    return true;
  }

  isPlayEnded(movesCount, gameTimer) {
    if (this.props.flipsNeeded && this.props.flipsNeeded <= movesCount) {
      return true;
    }
    return this.props.gameTime && this.props.gameTime <= gameTimer;
  }

  processGameResult(puzzlePieces, movesCount, gameTimer) {
    if (this.isGameWin(puzzlePieces)) {
      setTimeout(() => {
        this.processGameEnd(true);
        this.setState({isWin: true, isLose: false});
      }, 400);
      return true;
    } else if (this.isPlayEnded(movesCount, gameTimer)) {
      setTimeout(() => {
        this.processGameEnd(false);
        this.setState({isWin: false, isLose: true});
      }, 200);
      return true;
    }
    return false;
  }

  processGameEnd(isWin) {
    if (!this.endGameProcessStartTime) {
      this.endGameProcessStartTime = new Date().getTime();

      // Vibration.vibrate(200);
      if (isWin) {
        if (this.gamePlayAudioIdWin) {
          this.gamePlayAudioIdWin.play();
        }
      } else {
        if (this.gamePlayAudioIdNeutral) {
          this.gamePlayAudioIdNeutral.play();
        }
      }

      // const endGameValue = JSON.stringify({
      //   isWin: isWin,
      //   indexes: this.puzzlePieces,
      //   timer: this.state.gameTimer
      // });
      if (this.props.onEnd) {
        this.props.onEnd({
          isWin: isWin,
          indexes: this.puzzlePieces,
          timer: this.state.gameTimer
        });
      }
    }
  }

  getCardSize() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const rows = this.props.rows;
    const columns = this.props.columns;

    const cardSpacing = this.getCardSpacing();
    const otherUiHeight = 170 * sizeFactor;
    const borderWidth = 2 * uiConfigs.gameBgMarginStartEnd * sizeFactor;
    const borderHeight = (uiConfigs.gameBgMarginTop + uiConfigs.gameBgMarginBottom) * sizeFactor;
    const possibleWidth = (this.props.contentWidth - borderWidth - (columns - 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
    const possibleHeight = (this.props.contentHeight - otherUiHeight - borderHeight - (rows - 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
    const possibleSize = Math.min(possibleWidth, possibleHeight);
    const cardSize = Math.floor(Math.min(200, possibleSize));
    return cardSize;
  }

  getCardSpacing() {
    return 0;
  }
}

class Grid extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      tileDataSource: this.initializeDataSource(),
    };
  }

  getGridData() {
    return this.state.tileDataSource;
  }

  reset() {
    this.setState({tileDataSource: this.initializeDataSource()});
  }

  render() {
    return (
      <View
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          width: this.props.size * this.props.columns,
          height: this.props.size * this.props.rows,
          flexDirection: 'row',
          flexWrap: 'wrap'}}>
        {this.renderTiles(this.state.tileDataSource)}
      </View>
    );
  }

  renderTiles(tileData) {
    return <CardsView
      isLTR={this.props.isLTR}
      tileData={tileData}
      tileDataSource={this.state.tileDataSource}
      size={this.props.size}
      rows={this.props.rows}
      columns={this.props.columns}
      imageUrl={this.props.imageUrl}
      onChange={this.onCardChange}
    />;
  }

  onCardChange = () => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    const newTileDataSource = this.state.tileDataSource.slice();
    const selectedKeys = [];
    newTileDataSource.forEach((rowsTileData) => {
      rowsTileData.forEach((columnTileData) => {
        selectedKeys.push(columnTileData.selectedKey);
      });
    });
    if (this.props.onChange) {
      this.props.onChange(selectedKeys);
    }
    this.setState({tileDataSource: newTileDataSource});
  }

  initializeDataSource() {
    let keys = [];
    for (let i = 0; i < this.props.rows; i++) {
      let columns = [];
      for (let j = 0; j < this.props.columns; j++) {
        columns.push(i * this.props.rows + j);
      }
      keys.push(columns);
    }
    // let keys = [
    //     [0, 1, 2, 3, 4],
    //     [5, 6, 7, 8, 9],
    //     [10, 11, 12, 13, 14],
    //     [15, 16, 17, 18, 19],
    //     [20, 21, 22, 23, 24],
    // ];

    return keys.map((row, i) => {
      return row.map((key, j) => {
        const pieces = [];
        pieces.push(key);
        for (let counter = 0; counter < this.props.countPerPiece; counter++) {
          const random = this.getRandomInt(this.props.rows * this.props.columns, pieces);
          pieces.push(random);
        }
        let selectedIndex = this.getRandomInt(this.props.countPerPiece + 1);
        if (this.props.won) {
          selectedIndex = 0;
        }
        return new TileData(pieces, key, selectedIndex, pieces[selectedIndex]);
      });
    });
  }

  getIJ(key) {
    const ski = parseInt(key / this.props.rows);
    const skj = key % this.props.columns;
    return {ski, skj};
  }

  getRandomInt(max, excepts = undefined) {
    const random = Math.floor(Math.random() * Math.floor(max));
    if (excepts && excepts.includes(random)) {
      return this.getRandomInt(max, excepts);
    }
    return random;
  };
}

class TileData {

  constructor(pieces, key, selectedIndex, selectedKey) {
    this.key = key;
    this.selectedIndex = selectedIndex;
    this.selectedKey = selectedKey;
    this.pieces = pieces;
  }
}

const CardsView = React.memo((props) => {
  const {isLTR, tileData, size, rows, columns, imageUrl, onChange} = props;

  const onChangeL = (column) => {
    column.selectedIndex = (column.selectedIndex + 1) % column.pieces.length;
    column.selectedKey = column.pieces[column.selectedIndex];
    onChange();
  };

  let tiles = [];
  tileData.forEach((row, i) => {
    row.forEach((column, j) => {
      tiles.push(
        <CardView
          isLTR={isLTR}
          column={column}
          size={size}
          rows={rows}
          columns={columns}
          imageUrl={imageUrl}
          onChange={onChangeL}
        />
      );
    });
  });
  return tiles;
});

const CardView = React.memo((props) => {
  const {isLTR, column, size, rows, columns, imageUrl, onChange} = props;

  const onChangeL = () => {
    onChange(column);
  };

  const getIJ = (key) => {
    const ski = parseInt(key / rows);
    const skj = key % columns;
    return {ski, skj};
  }
  const {ski, skj} = getIJ(column.selectedKey);
  logDebug('IJ', {key: column.key, selectedKey: column.selectedKey, ski, skj});

  return (
    <TouchableOpacity onClick={onChangeL}>
      <View key={column.key +'-'+ column.selectedKey} style={{overflow: 'hidden', width: size, height: size, padding: 1}}>
        <View style={{overflow: 'hidden', width: size - 2, height: size - 2}}>
          <AppImage
            key={column.key +'-'+ column.selectedKey}
            style={{
              width: size * rows,
              height: size * columns,
              marginLeft: isLTR ? -size * skj : 0,
              marginRight: !isLTR ? -size * skj : 0,
              marginTop: -size * ski,
            }}
            imageUrl={imageUrl}
          />
        </View>
      </View>
    </TouchableOpacity>
  );
});
